import type { GetTweetFeed200TweetsItemContent } from './getTweetFeed200TweetsItemContent';
import type { GetTweetFeed200TweetsItemMediaItem } from './getTweetFeed200TweetsItemMediaItem';
import type { GetTweetFeed200TweetsItemPoll } from './getTweetFeed200TweetsItemPoll';
import type { GetTweetFeed200TweetsItemStats } from './getTweetFeed200TweetsItemStats';
import type { GetTweetFeed200TweetsItemTags } from './getTweetFeed200TweetsItemTags';
import type { GetTweetFeed200TweetsItemTweetType } from './getTweetFeed200TweetsItemTweetType';

export type GetTweetFeed200TweetsItem = {
  authorDisplayName?: string;
  authorId?: string;
  authorProfileImageUrl?: string;
  authorUsername?: string;
  content?: GetTweetFeed200TweetsItemContent;
  createdAt?: string;
  isLiked?: boolean;
  isRetweeted?: boolean;
  media?: GetTweetFeed200TweetsItemMediaItem[];
  poll?: GetTweetFeed200TweetsItemPoll;
  /**
   * ID of the referenced tweet (for replies and quotes)
   * @nullable
   */
  referencedTweetId?: string | null;
  stats?: GetTweetFeed200TweetsItemStats;
  tags?: GetTweetFeed200TweetsItemTags;
  tweetId?: string;
  /** Type of tweet */
  tweetType?: GetTweetFeed200TweetsItemTweetType;
  updatedAt?: string;
};
